module.exports = __webpack_public_path__ + "static/github-file-focus-088d1373f61359ab0ce89ce65759ddf9.png";